module.exports = __webpack_public_path__ + "static/logo-b73048211d7a9a05b4c449061f130c5f.png";